<template>
	<div class="img-color-overlay">
		<div class="container">
			<div class="row section-separator">
				<div class="col-sm-12 section-title wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.2s" style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.2s; animation-name: none;">
					<h3>{{ $t('blog.featuredPosts') }}</h3>
				</div>
				<div class="col-sm-12 col-md-4" v-for="(article, i) in showArticles" :key="i">
					<div class="mh-blog-item dark-bg wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.3s" style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.3s; animation-name: none;">
						<div class="row mx-5">
							<div class="col-sm-12 col-md-5 mt-5">
								<img :src="article.cover_img" alt="" class="img-fluid">
							</div>
							<div class="col-sm-12 col-md-7 mt-5">
								<ul class="pl-0">
									<li><strong>{{ $t('blog.postOn') }}</strong></li>
									<li class="mt-2">{{ $tools.formatDateTime(Number(article.create_time) * 1000) }}</li>
									<li class="mt-10"><a target="_blank" :href="article.url">{{ $t('blog.readMore') }}</a></li>
								</ul>
							</div>
						</div>
						<div class="row">
							<div class="col-sm-12 col-md-12">
								<div class="blog-inner">
									<h2><a target="_blank" :href="article.url" class="primary-text">{{ locale == 'zh-CN' ? article.title : $pinyin.getPinyin(article.title, ' ', true) }}</a></h2>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="text-center mb-10" v-if="articles.length > 6">
				<h5>
                    <router-link to="/blogs">{{ $t('blog.showMore') }}</router-link>
					<!-- <a class="fs-18" @click="changeShowArticles()" v-show="articles.length > showArticles.length">{{ $t('blog.showMore') }}</a>
					<a class="fs-18" @click="changeShowArticles()" v-show="articles.length == showArticles.length">{{ $t('blog.showLess') }}</a> -->
				</h5>
			</div>
		</div>
	</div>
</template>
<script>
import BlogAPI from '@/api/blog.js'
import { mapGetters } from 'vuex'
export default {
    data(){
        return {
			// 所有文章集合
         	articles: [],
			// 显示文章集合
			showArticles: [],
			// 备份展示文章集合
			bakShowArticles: [],
        }
    },
    components: {  },
    created(){

    },
    mounted(){
      this.getArticles();
    },
    computed: {
		...mapGetters(['locale'])
    },
    watch:{

    },
    methods: {
		async getArticles(){
			let res = await BlogAPI.getArticles();
			let data = res.data;
			if(data.code == 200) {
				this.articles = data.data;
				if(data.data.length > 6) {
					this.showArticles = data.data.slice(0, 6);
					this.bakShowArticles = data.data.slice(0, 6);
				} else {
					this.showArticles = data.data;
					this.bakShowArticles = data.data;
				}
			}
		},
		// 展示文章
		changeShowArticles(){
			if(this.showArticles.length < this.articles.length){
				this.showArticles = JSON.parse(JSON.stringify(this.articles));
			} else {
				this.showArticles = JSON.parse(JSON.stringify(this.bakShowArticles));
			}
		}
    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Blog.vue